import { suppliesTrackableProductIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const deleteTrackableProduct = unaryRpc({
  name: "deleteTrackableProduct" as const,
  input: z.object({
    trackableProductId: suppliesTrackableProductIdFormat.schema,
  }),
  output: z.object({}),
});
